module.exports = __webpack_public_path__ + "img/zapier-mini.4c254df5.png";